export default {
  from: 'från',
  select: 'Fortsätt',
  deal: 'erbjudande',
  deals: 'erbjudanden',
  total: 'totalt',
  total_fr: '',
  pp: 'pp',
}
